module.exports = __webpack_public_path__ + "img/PL08077.0abd7538.png";